import api from "./axios";

export const getUsers = (query = "") =>
  api.get("/users", { params: { q: query } }).then((res) => res.data);

export const updateUserRoles = (userId, roles) =>
  api.put(`/users/${userId}/roles`, { roles }).then((res) => res.data);

export const createUser = ({ fullName, email, roles }) => {
  api.post("/users", { fullName, email, roles }).then((r) => r.data);
};

export const deleteUser = (userId) => {
  api.delete(`/users/${userId}`).then((r) => r.data);
};
